// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3xAIW","label":"LabeledBox_label__5Z8V-"};